/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestCreateRequest } from '../../models/harvest-create-request';
import { HarvestFullResponse } from '../../models/harvest-full-response';

export interface CreateHarvest$Params {
      body: HarvestCreateRequest
}

export function createHarvest(http: HttpClient, rootUrl: string, params: CreateHarvest$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestFullResponse>> {
  const rb = new RequestBuilder(rootUrl, createHarvest.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestFullResponse>;
    })
  );
}

createHarvest.PATH = '/api/harvests';
